export default () => ({
  show: false,
  wasRaised: false,
  beenUpdated: false,
  saved: false,
  covenant: {
    covenant_id: null,
    active: true,
    plans: [],
    covenant: {}
  },
  plans: [],
  includes: ['covenant', 'plans'],
  nextStepButtonCompanyCovenants: [
    {
      icon: '',
      text: 'Novo Convênio Médico',
      name: 'professional.company.covenants.create',
      action: null
    },
    {
      icon: '',
      text: 'Corpo Clínico',
      name: 'professional.company.staffs.create',
      action: null
    },
    {
      icon: '',
      text: 'Honorários Médicos',
      name: 'professional.company.prices.create',
      action: null
    }
  ],
  nextStepButtonIsCompanyCovenants: [
    {
      icon: '',
      text: 'Novo Convênio Médico',
      name: 'professional.company.covenants.create',
      action: null
    },
    {
      icon: '',
      text: 'Honorários Médicos',
      name: 'professional.company.prices.create',
      action: null
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/edit/resources/data.js